<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard Financeiro</h3>
        </div>
      </div>
      <profit class="margin-profit" :dashboard="true" />
    </div>
  </div>
</template>

<script>
import profit from "./profit";
export default {
  name: "financial-dashboard",
  components: {
    profit
  },
  data: function() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.margin-profit {
  margin-left: -15px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/financialDashboard.vue